import React from 'react';
import './videopopup.css'
import Modal from 'react-modal';

Modal.setAppElement('#root'); // Necesario para cumplir con las pautas de accesibilidad

const customStyles = {
  content: {
    display: 'absolute',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white', // Cambiado de background-color a backgroundColor
    padding: '20px',
    border: '1px solid #ccc',
    zindex: 1000,
  }
};


const VideoPopup = ({ isOpen, onClose, videoURL }) => {

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className='customPop' style={customStyles}>
      <div>
      <button onClick={onClose} style={customStyles.closeButton}>
          X
        </button>
        <iframe className='iframe' src={videoURL} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>

        </iframe>
      </div> 
    </Modal>
  );
};

export default VideoPopup;
